

import { storeToRefs } from "pinia";
import { OffCanvasPages, EOffcanvasPage, IOffcanvasPage } from "./canvas.pages";
import { useCanvasStore } from "./useCanvasStore";

export default function useOffCanvas() {
    const canvasStore = useCanvasStore()
    const { push, pop, clearStack, replace } = canvasStore
    const { topItemInStack, canvasStack } = storeToRefs(canvasStore)

    const navigateCanvas = (to: EOffcanvasPage, page: Partial<IOffcanvasPage> | null = null) => {
        let toggle = !topItemInStack.value
        const conf = {
            ...OffCanvasPages[to],
            ...page
        }
        if (topItemInStack.value?.key != to) {
            push(conf)
        }

        if (toggle) toggleOffcanvas();
    };
    const replaceCanvas = (to: EOffcanvasPage, page: Partial<IOffcanvasPage> | null = null) => {
        const newPage = {
            ...OffCanvasPages[to],
            ...page
        }
        replace(newPage)
    };


    const closeCanvas = () => {
        clearStack()
        const offCanvasRef = document.getElementById("offcanvas");
        const hasOffCanvasOpened = offCanvasRef?.className.includes("show")
        if (hasOffCanvasOpened) {
            toggleOffcanvas();
        }
    }

    const canvasBackPressed = () => {
        console.log('stack', canvasStack.value.length)
        if (canvasStack.value.length == 1) {
            toggleOffcanvas()
        }
        pop()

    };


    const toggleOffcanvas = () => {
        const button = document.getElementById(`offcanvas_button`);
        if (button) {
            button?.click();
        }
    };

    return {
        navigateCanvas,
        closeCanvas,
        canvasBackPressed,
        toggleOffcanvas,
        replaceCanvas,
        topItemInStack

    }

}